import {
  CLOSE_BROADCAST_BANNER_DIALOG,
  CREATE_NEW_BROADCAST_BANNER,
  DELETE_BROADCAST_BANNER,
  EDIT_BROADCAST_BANNER,
  GET_BROADCAST_BANNER,
  OPEN_BROADCAST_BANNER_DIALOG,
  BROADCAST_BANNER_VIP_SWITCH,
} from "./types";

const initialState = {
  banner: [],
  dialog: false,
  dialogData: null,
};

const broadcastBannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BROADCAST_BANNER:
      return {
        ...state,
        banner: action.payload,
      };
    case CREATE_NEW_BROADCAST_BANNER:
      const data = [...state.banner];
      data.unshift(action.payload);
      return {
        ...state,
        banner: data,
      };
    case EDIT_BROADCAST_BANNER:
      return {
        ...state,
        banner: state.banner.map((banner) => {
          if (banner._id === action.payload.id) return action.payload.data;
          else return banner;
        }),
      };
    case DELETE_BROADCAST_BANNER:
      return {
        ...state,
        banner: state.banner.filter((banner) => banner._id !== action.payload),
      };
    case BROADCAST_BANNER_VIP_SWITCH:
      return {
        ...state,
        banner: state.banner.map((banner) => {
          if (banner._id === action.payload._id)
            return {
              ...banner,
              isVIP: action.payload.isVIP,
            };
          else return banner;
        }),
      };
    case OPEN_BROADCAST_BANNER_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };
    case CLOSE_BROADCAST_BANNER_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };

    default:
      return state;
  }
};

export default broadcastBannerReducer;
